/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const teamMemberRoleEnum = {
  channels: 'channels',
  viewer: 'viewer',
  contributor: 'contributor',
  commercial: 'commercial',
  admin: 'admin',
  owner: 'owner',
} as const;

export type TeamMemberRoleEnumSchemaKey = (typeof teamMemberRoleEnum)[keyof typeof teamMemberRoleEnum];

export type TeamMemberRoleSchema = TeamMemberRoleEnumSchemaKey;
